var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c("div", { staticClass: "PopupContainer" }, [
        _c("div", { staticClass: "PopupContainer__wrapper" }, [
          _c(
            "div",
            {
              staticClass: "PopupContainer__close",
              on: { click: _vm.handlePopupClose }
            },
            [
              _c(
                "svg",
                {
                  staticClass: "feather feather-x",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }
                },
                [
                  _c("line", {
                    attrs: { x1: "18", y1: "6", x2: "6", y2: "18" }
                  }),
                  _vm._v(" "),
                  _c("line", {
                    attrs: { x1: "6", y1: "6", x2: "18", y2: "18" }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "PopupContainer__content" },
            [_vm._t("default")],
            2
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c910bc0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /Users/mrkaluzny/Developer/tarasy-nad-stawem/web/app/themes/tarasy-nad-stawem/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c910bc0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!/Users/mrkaluzny/Developer/tarasy-nad-stawem/web/app/themes/tarasy-nad-stawem/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/vue/components/PopupContainer.vue
// module id = 65
// module chunks = 0